export const whyRinnaiHero = {
  breadcrumb: "Why Rinnai",
  eyebrow: "WHY RINNAI · PERTH WA",
  title: "Why choose Rinnai",
  highlight: "air conditioning?",
  intro: "Rinnai has supplied Australian homes for more than 50 years. Its air conditioning is designed for Australian conditions, backed by a 7 year warranty on eligible systems and supported by 1stCare, Rinnai’s national service network. That combination is why we specialise in it.",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/e364bf79-dfb5-48a3-b366-c1647a4e8f28.jpg",
  imageAlt: "Woman relaxing in a bright Perth living room with a wall-mounted air conditioner",
  facts: ["50+ years in Australian homes", "7 year warranty*", "1stCare national service"],
};

export const whyRinnaiQuickAnswer = {
  question: "Is Rinnai a good air conditioning brand?",
  answer: "Yes. Rinnai is a long-established supplier to Australian homes and part of Japan’s Rinnai Corporation. Its split, multi-split and ducted systems use inverter technology, are designed for Australian conditions and carry a 7 year warranty on eligible systems. As with any brand, the result in your home depends on correct sizing and installation.",
  points: [
    { label: "In Australia", value: "More than 50 years" },
    { label: "Parent company", value: "Rinnai Corporation, Japan" },
    { label: "Group brands", value: "Brivis, APAC and iZone" },
    { label: "Warranty", value: "7 years on eligible systems*" },
    { label: "Service", value: "1stCare national network" },
    { label: "Efficiency", value: "Up to 9 stars on selected series" },
  ],
};

export const whyRinnaiReasons = [
  {
    title: "Designed for Australian conditions",
    text: "Rinnai ducted systems are built to operate from -20°C to +50°C outdoors, and the TX Series is designed for Australia’s ever-changing climate.",
  },
  {
    title: "Efficient inverter technology",
    text: "DC inverter compressors adjust output to demand. Selected split series reach up to 9 stars, and ducted systems deliver around 3kW of output for every 1kW used.",
  },
  {
    title: "A 7 year warranty",
    text: "Eligible Rinnai split and ducted air conditioners carry a 7 year warranty, one of the strongest in the Australian market.",
  },
  {
    title: "1stCare national service",
    text: "Rinnai’s own service network uses qualified technicians and genuine spare parts across Rinnai, Brivis, APAC, Polo and select iZone products.",
  },
  {
    title: "Healthier, better protected systems",
    text: "HEPA filtration on the TX Series, GoldGuard corrosion protection for coastal homes and lower-impact R32 refrigerant on current models.",
  },
  {
    title: "One connected ecosystem",
    text: "Split, multi-split and ducted systems, Rinnai Home Controller and iZone smart control all sit within the same Rinnai group.",
  },
];

export const whyRinnaiService = {
  eyebrow: "WARRANTY AND SERVICE",
  title: "Peace of mind that lasts beyond installation day.",
  text: "Eligible Rinnai split and ducted systems carry a 7 year warranty. If your system ever needs attention, 1stCare, Rinnai’s national service network, sends qualified technicians who use genuine spare parts.",
  points: [
    "7 year warranty on eligible systems*",
    "1stCare national service network",
    "Genuine Rinnai spare parts",
    "Service Monday to Friday, 8:30am to 5:00pm AEST",
  ],
  image: "https://cdn.magicpatterns.com/patterns/generated-images/5c1c3737-939c-4098-b1a8-18a6c6c7a9b8.jpg",
  imageAlt: "Calm bedroom with a wall-mounted split system air conditioner",
  note: "*Warranty terms and conditions apply. Full details are available from Rinnai Australia.",
};

export const whyRinnaiRange = {
  columns: ["Rinnai system", "Best for", "Key facts"],
  rows: [
    ["Split systems", "Bedrooms, living areas and home offices", "Reverse cycle inverter, up to 9 stars on selected series"],
    ["Multi-split", "Several rooms with one outdoor unit", "Independent room control and less outdoor clutter"],
    ["Ducted", "Whole-home comfort", "7kW to 24kW, up to 8 zones with Rinnai Home"],
    ["Mini VRF", "Multiple rooms in modern homes", "Automatically adjusts output room by room"],
    ["iZone smart control", "Smarter ducted homes", "Up to 14 zones, app and voice control"],
  ],
};

export const whyRinnaiInstaller = {
  eyebrow: "RINNAI PRODUCT. PERTH INSTALLATION.",
  title: "A great brand still needs the right installer.",
  text: "Rinnai engineers the product. How it performs in your home depends on sizing, duct design and installation quality. That is where Perth Home Air Conditioning comes in: 30+ years of Perth experience and ARC Tick licensed installers, focused on Rinnai.",
  points: [
    "Heat load based sizing",
    "Duct and zone design",
    "ARC Tick licensed installation",
    "One local point of contact",
  ],
  image: "https://cdn.magicpatterns.com/patterns/generated-images/b80105bc-e292-4256-9ccf-ad8e6bc6cfd6.jpg",
  imageAlt: "Installer fitting a linear ceiling air diffuser in a Perth home",
  cta: { label: "Why choose Perth Home Air Conditioning", to: "/why-us" },
};
